module.exports = __webpack_public_path__ + "static/img/massage_img4.1f22bbc1.png";